import _classCallCheck from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _slicedToArray from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["## Dependencies"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n\nThe order of the full icosahedral symmetry group is 120, but the order of the\nsubgroup of proper rotations is only 60.  For this rendering, we are only doing\nrotations, without any reflections, to generate the vectors in an orbit.\nThis means that roughly half of the sphere is not showing any vector cones.\nOnly the orbits lying on the blue mirror planes are fully represented.\n\n## Code and Data"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["The \"Orbits Generated\" slider how many of the generated orbits are rendered\nas vectors, represented by very narrow cones."]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["This rendering is a somewhat novel way of representing the vector orbits\nof the icosahedral symmetry group, designed by\n[Jacob Rus](https://beta.observablehq.com/@jrus) and [Scott Vorthmann](https://beta.observablehq.com/@vorth).\nOrbit colors are assigned to match [vZome](http://vzome.com) coloring\nas much as possible.  Orbits unknown to vZome are colored ivory.\n\nStarting from the mirror planes and their axes (the blue lines in\n[Zome](http://zometool.com)), the remaining orbits have been generated\nby choosing two known vectors and taking their cross product.\nIf the result represents an unknown orbit, the orbit is added to the\never-growing list.\n\nThis means that new vectors appear at the intersections of existing planes.\nFor example, with the ordering of blue vectors that we are using,\nthe \"orange\" orbit appears at the intersection of the red and blue planes.\n\nFor the first few orbits, the planes orthogonal to its vectors\nare rendered.  The number of orbits rendered this way is\ncontrolled by the value of the \"Orbits as Great Circles\" slider."]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["# Orbits of Icosahedral Symmetry"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// https://observablehq.com/@vorth/orbits-of-icosahedral-symmetry@3195
import define1 from "../@vorth/wip-observable-vzome.js";
import define2 from "../@vorth/wip-importing-vzome-shapes.js";
import define3 from "../@jrus/zome-arithmetic.js";
import define4 from "../@vorth/reusable-three-js-canvas.js";
import define5 from "../@jashkenas/inputs.js";
export default function define(runtime, observer) {
  var main = runtime.module();
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject());
  });
  main.variable(observer("viewof ranks")).define("viewof ranks", ["slider"], function (slider) {
    return slider({
      min: 0,
      max: 40,
      step: 1,
      value: 20,
      title: "Orbits to Generate",
      description: "Control the number of orbits rendered as cones"
    });
  });
  main.variable(observer("ranks")).define("ranks", ["Generators", "viewof ranks"], function (G, _) {
    return G.input(_);
  });
  main.variable(observer("viewof rings")).define("viewof rings", ["slider"], function (slider) {
    return slider({
      min: 0,
      max: 20,
      step: 1,
      value: 6,
      title: "Orbits as Great Circles",
      description: "Control the number of orbits whose orthogonal planes are rendered as great circles"
    });
  });
  main.variable(observer("rings")).define("rings", ["Generators", "viewof rings"], function (G, _) {
    return G.input(_);
  });
  main.variable(observer("rendering")).define("rendering", ["reusable3dCanvas", "orbitSphere"], function (reusable3dCanvas, orbitSphere) {
    return reusable3dCanvas(this, orbitSphere, {
      renderWidth: 650,
      camera: {
        aspect: 5 / 3,
        position: [270, 40, 20]
      }
    });
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject2());
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject3());
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject4());
  });
  main.variable(observer("orbitSphere")).define("orbitSphere", ["THREE", "rings", "orbit2quaternion", "icosahedral_quaternions", "grfloat", "ranks", "rankedOrbits", "colors"], function (THREE, rings, orbit2quaternion, icosahedral_quaternions, grfloat, ranks, rankedOrbits, colors) {
    var group = new THREE.Group();
    var sphereGeom = new THREE.SphereGeometry(75, 99, 99);
    var white = new THREE.MeshLambertMaterial({
      color: 0xffffff
    });
    white.opacity = 0.8;
    white.transparent = false;
    var sphere = new THREE.Mesh(sphereGeom, white);
    group.add(sphere);
    var zoneGeom = new THREE.ConeGeometry(1, 86, 32, 3, false);
    var zoneToZ = new THREE.Quaternion();
    zoneToZ.setFromUnitVectors(new THREE.Vector3(0, -1, 0), new THREE.Vector3(0, 0, 1));

    function addZone(rotationFromZ, material, i) {
      var ringMin = 75;
      var ringMax = 85 - i;

      if (i < rings && ringMax > ringMin) {
        var ringGeom = new THREE.RingGeometry(ringMin, ringMax, 99);
        var mesh = new THREE.Mesh(ringGeom, material);
        var q = mesh.quaternion,
            r = rotationFromZ;
        var _ref = [r.w, r.x, r.y, r.z];
        q.w = _ref[0];
        q.x = _ref[1];
        q.y = _ref[2];
        q.z = _ref[3];
        group.add(mesh);
      }

      var zoneMesh = new THREE.Mesh(zoneGeom, material);
      var q1 = new THREE.Quaternion();
      q1.multiplyQuaternions(rotationFromZ, zoneToZ);
      var q2 = zoneMesh.quaternion;
      var _ref2 = [q1.w, q1.x, q1.y, q1.z];
      q2.w = _ref2[0];
      q2.x = _ref2[1];
      q2.y = _ref2[2];
      q2.z = _ref2[3];
      var vector = new THREE.Vector3(0, -42, 0);
      vector.applyQuaternion(q2);
      var p = zoneMesh.position;
      var _ref3 = [vector.x, vector.y, vector.z];
      p.x = _ref3[0];
      p.y = _ref3[1];
      p.z = _ref3[2];
      group.add(zoneMesh);
    }

    function addOrbit(orbit, color, i) {
      var mirror = orbit.name == "blue";
      var material = new THREE.MeshLambertMaterial({
        color: color,
        side: THREE.DoubleSide
      });
      var zToPrototype = new THREE.Quaternion();
      orbit2quaternion(orbit, zToPrototype); // addZone( zToPrototype, material, i );

      icosahedral_quaternions.map(function (icosaQuat) {
        var q = new THREE.Quaternion();

        var _icosaQuat$map = icosaQuat.map(grfloat);

        var _icosaQuat$map2 = _slicedToArray(_icosaQuat$map, 4);

        q.w = _icosaQuat$map2[0];
        q.x = _icosaQuat$map2[1];
        q.y = _icosaQuat$map2[2];
        q.z = _icosaQuat$map2[3];
        var q1 = new THREE.Quaternion();
        q1.multiplyQuaternions(q, zToPrototype);
        addZone(q1, material, i);
      });
    }

    for (var i = 0; i <= ranks; i++) {
      addOrbit(rankedOrbits[i].orbit, colors[rankedOrbits[i].name || "ivory"], i);
    }

    return group;
  });
  main.variable(observer("orbits")).define("orbits", ["golden_icosahedral_symmetry", "colors"], function (golden_icosahedral_symmetry, colors) {
    return Object.entries(golden_icosahedral_symmetry.orbits).map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          key = _ref5[0],
          value = _ref5[1];

      return {
        orbit: value.prototype.slice(1),
        color: colors[key]
      };
    });
  });
  main.variable(observer("orbit2quaternion")).define("orbit2quaternion", ["orbit2quatf"], function (orbit2quatf) {
    return function orbit2quaternion(orbit, q) {
      var _orbit2quatf = orbit2quatf(orbit);

      var _orbit2quatf2 = _slicedToArray(_orbit2quatf, 4);

      q.w = _orbit2quatf2[0];
      q.x = _orbit2quatf2[1];
      q.y = _orbit2quatf2[2];
      q.z = _orbit2quatf2[3];
    };
  });
  main.variable(observer("IndexedSet")).define("IndexedSet", function () {
    return (
      /*#__PURE__*/
      function () {
        function IndexedSet() {
          _classCallCheck(this, IndexedSet);

          this.contents = [];
          this.map = new Map();
        }

        _createClass(IndexedSet, [{
          key: "add",
          value: function add(item) {
            var itemhash = JSON.stringify(item);
            var index = this.map.get(itemhash);

            if (index == null) {
              index = this.contents.length;
              this.contents.push(item);
              this.map.set(itemhash, index);
            }

            return index;
          }
        }]);

        return IndexedSet;
      }()
    );
  });
  main.variable(observer("rankedOrbits")).define("rankedOrbits", ["IndexedSet", "icosahedral_symmetry", "wedge", "orbit2", "orbitnames"], function (IndexedSet, icosahedral_symmetry, wedge, orbit2, orbitnames) {
    var orbits = new IndexedSet();
    var json = JSON.stringify;
    var zero = json([[0, 0, 1], [0, 0, 1], [0, 0, 1]]);
    orbits.add([[1, 0, 1], [0, 0, 1], [0, 0, 1]]);

    for (var i = 0; i < 10; i++) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = icosahedral_symmetry(orbits.contents[i])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var u = _step.value;

          for (var j = 0; j <= i; j++) {
            var v = orbits.contents[j];
            var uv = wedge(u, v);
            if (json(uv) == zero) continue;

            var _orbit = orbit2(uv),
                _orbit2 = _slicedToArray(_orbit, 4),
                orbit = _orbit2[0],
                rotation = _orbit2[1],
                reflected = _orbit2[2],
                length = _orbit2[3];

            orbits.add([[1, 0, 1]].concat(orbit));
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }

    return orbits.contents.map(function (u) {
      return {
        orbit: u.slice(1),
        name: orbitnames[json(orbit2(u)[0])]
      };
    });
  });
  main.variable(observer("orbit2quatf")).define("orbit2quatf", ["grfloat"], function (grfloat) {
    return function orbit2quatf(_ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
          a = _ref7[0],
          b = _ref7[1];

      a = grfloat(a), b = grfloat(b);
      var r = Math.sqrt(1 + a * a + b * b);
      var denom = 1 / Math.sqrt(2 * r * (r + 1));
      return [denom * (r + 1), -denom * b, denom * a, 0];
    };
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject5());
  });
  var child1 = runtime.module(define1);
  main.import("colors", child1);
  var child2 = runtime.module(define2);
  main.import("golden_icosahedral_symmetry", child2);
  var child3 = runtime.module(define3);
  main.import("icosahedral_quaternions", child3);
  main.import("grfloat", child3);
  main.import("wedge", child3);
  main.import("orbit2", child3);
  main.import("icosahedral_symmetry", child3);
  main.import("orbitnames", child3);
  var child4 = runtime.module(define4);
  main.import("reusable3dCanvas", child4);
  main.import("THREE", child4);
  var child5 = runtime.module(define5);
  main.import("slider", child5);
  return main;
}